import React from "react";
import { Paper, Box, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { tokens } from "../../theme";
import { RootState } from "../../store/Index";

export interface CardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  headerAction?: React.ReactNode;
  footer?: React.ReactNode;
  padding?: number | string;
  elevation?: number;
  onClick?: () => void;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  headerAction,
  footer,
  padding = 3,
  elevation = 0,
  onClick,
  children,
}) => {
  const theme = useTheme();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const colors = tokens(theme.palette.mode, reduxTheme);

  return (
    <Paper
      elevation={elevation}
      onClick={onClick}
      sx={{
        borderRadius: "16px",
        border: `1px solid ${colors.primary[300]}20`,
        backgroundColor: colors.primary[900],
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {(title || subtitle || headerAction) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            px: padding,
            pt: padding,
            pb: subtitle ? 0.5 : 1.5,
          }}
        >
          <Box>
            {title && (
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: colors.primary[100] }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="body2" sx={{ color: colors.primary[300] }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {headerAction}
        </Box>
      )}

      <Box
        sx={{ px: padding, pb: padding, pt: title || subtitle ? 0 : padding }}
      >
        {children}
      </Box>

      {footer && (
        <Box
          sx={{
            px: padding,
            py: 2,
            borderTop: `1px solid ${colors.primary[300]}20`,
          }}
        >
          {footer}
        </Box>
      )}
    </Paper>
  );
};

export default Card;
